export default __webpack_public_path__ + "static/media/delete.196822ca.svg";